module.exports = __webpack_public_path__ + "img/nav-design-vintage@2x.4691736.webp";